import React, { useState, useEffect } from 'react';
import {
    GridColumnHeaderTitle,
    GridFilterModel, GridHeader, GridLogicOperator,
} from '@mui/x-data-grid';
import {
    FormControl, FormGroup, FormControlLabel, Checkbox, Menu, Button,
    ListItemText, ListItemIcon, MenuItem, Box, Paper, Stack, Typography
} from '@mui/material';
import TuneIcon from '@mui/icons-material/Tune';

interface CustomResponsiblePersonFilterProps {
    valueOptions: string[];
    setFilterResponsiblePerson: any;
}

export const ProjectDataGridFilterResponsiblePerson: React.FC<CustomResponsiblePersonFilterProps> = ({ valueOptions, setFilterResponsiblePerson }) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [selectedResponsiblePerson, setSelectedResponsiblePerson] = useState<string[]>([]);

    const openMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        setAnchorEl(event.currentTarget);
    };

    const closeMenu = () => {
        setAnchorEl(null);
    };

    const handleApplyFilter = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        setFilterResponsiblePerson(selectedResponsiblePerson);
        closeMenu();
    };

    const handleSelectAllFilter = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        setSelectedResponsiblePerson([...valueOptions, '']);
        setFilterResponsiblePerson([...valueOptions, '']);
    };

    const handleClearFilter = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation();
        setSelectedResponsiblePerson([]);
        setFilterResponsiblePerson([]);
    };

    const handleResponsiblePersonChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        event.stopPropagation();
        const { name, checked } = event.target;
        const updatedResponsiblePerson = [...selectedResponsiblePerson];
        if (checked) {
            updatedResponsiblePerson.push(name);
        } else {
            const index = updatedResponsiblePerson.indexOf(name);
            if (index !== -1) {
                updatedResponsiblePerson.splice(index, 1);
            }
        }
        setSelectedResponsiblePerson(updatedResponsiblePerson);
        setFilterResponsiblePerson(updatedResponsiblePerson);
    };

    return (
        <Box>
            <Button
                variant={selectedResponsiblePerson.length >= valueOptions.length || selectedResponsiblePerson.length == 0 ? 'text' : 'contained'}
                onClick={openMenu}
                size='small'
                color={selectedResponsiblePerson.length >= valueOptions.length || selectedResponsiblePerson.length == 0 ? 'inherit' : 'primary'}
                sx={{ textTransform: 'none', width: '120px' }}
            >
                <Stack direction={'row'} alignItems={'center'} justifyContent={'space-evenly'} width={'100%'}>
                    <Typography variant='body2'>
                        Responsible
                    </Typography>
                    <TuneIcon fontSize='small' />
                </Stack>
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={closeMenu}
            >
                <Stack
                    direction='column'
                    sx={{ m: 1, my: 0 }}
                    spacing={1}
                >
                    <FormControl component='fieldset' sx={{ m: 0, p: 0, maxHeight: '600px', overflow: 'auto' }}>
                        <FormGroup>
                            {valueOptions.map((responsible_person) => (
                                <FormControlLabel
                                    key={responsible_person}
                                    control={
                                        <Checkbox
                                            name={responsible_person}
                                            checked={selectedResponsiblePerson.includes(responsible_person)}
                                            onChange={handleResponsiblePersonChange}
                                        />
                                    }
                                    label={responsible_person ? responsible_person : 'Nobody'}
                                />
                            ))}
                        </FormGroup>
                    </FormControl>
                    <Stack direction={'column'} spacing={1}>
                        <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} spacing={1}>
                            <Button
                                onClick={(e) => handleSelectAllFilter(e)}
                                variant='contained'
                                fullWidth
                            >
                                All
                            </Button>
                            <Button
                                onClick={(e) => handleClearFilter(e)}
                                variant='contained'
                                fullWidth
                            >
                                Clear
                            </Button>
                        </Stack>
                        {/* <Button
                            onClick={(e) => handleApplyFilter(e)}
                            variant='contained'
                        >
                            Apply
                        </Button> */}
                    </Stack>
                </Stack>
            </Menu>
        </Box>
    );
};
